/**
 * Pure helpers that read drill-down / table Format-popup keys. Shared by the
 * drill-down step (widget data) and the table-matrix step (capabilities).
 */

export function level2ColorConfig(fmt: Record<string, unknown>): Record<string, unknown> {
  const mode = String(fmt['drillLevel2ColorBy'] || '').trim();
  return !mode || mode === 'none' ? {} : { level2ColorBy: mode };
}

export function yearFilterCountFrom(fmt: Record<string, unknown>): number | undefined {
  if (fmt['yearFilter'] !== true) return undefined;
  const n = Number(fmt['yearFilterCount']);
  return Number.isFinite(n) && n > 0 ? Math.floor(n) : 3;
}

export function yearFilterBaseFrom(fmt: Record<string, unknown>): 'data' | 'current' | undefined {
  if (fmt['yearFilter'] !== true) return undefined;
  return fmt['yearFilterBase'] === 'current' ? 'current' : 'data';
}

export function yearFilterFieldFrom(fmt: Record<string, unknown>): string | undefined {
  if (fmt['yearFilter'] !== true) return undefined;
  return String(fmt['yearFilterField'] ?? '').trim() || undefined;
}

export function yearFilterConfig(fmt: Record<string, unknown>): Record<string, unknown> {
  const count = yearFilterCountFrom(fmt);
  return count === undefined ? {} : { yearFilterCount: count, yearFilterBase: yearFilterBaseFrom(fmt) };
}

/** One visual rule (data bar / heat map / …) per measure column, from the `drillVisualKind` / `drillVisualColor` keys. */
export function buildDrillDownVisualRules(measureKeys: string[], fmt: Record<string, unknown>): Record<string, unknown> {
  const kind = String(fmt['drillVisualKind'] || '').trim();
  if (!kind || kind === 'none') return {};
  const color = String(fmt['drillVisualColor'] || '#3b82f6');
  const rules: Record<string, unknown> = {};
  measureKeys.forEach((key) => { rules[key] = { kind, color }; });
  return rules;
}
